import { call, put, takeLatest } from 'redux-saga/effects';
import visitTypeService from '../../../services/visitTypeService';
import {
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchVisitTypes,
  fetchVisitTypesSuccess,
  fetchVisitTypesFailure,
  fetchVisitTypeById,
  fetchVisitTypeByIdSuccess,
  fetchVisitTypeByIdFailure,
  addVisitType,
  addVisitTypeSuccess,
  addVisitTypeFailure,
  updateVisitType,
  updateVisitTypeSuccess,
  updateVisitTypeFailure,
  deleteVisitType,
  deleteVisitTypeSuccess,
  deleteVisitTypeFailure,
  bulkDeleteVisitTypes,
  bulkDeleteVisitTypesSuccess,
  bulkDeleteVisitTypesFailure,
} from './slice';

function* handleFetchInit() {
  try {
    const response = yield call(visitTypeService.getInit);
    yield put(fetchInitSuccess(response));
  } catch (error) {
    yield put(fetchInitFailure(error.message));
  }
}

function* handleFetchVisitTypes(action) {
  try {
    const { page, pageSize, sortColumn, sortDirection, name: _ignored, filterName } = action.payload || {};

    const params = {};
    if (page) params.page = page;
    if (pageSize) params.pageSize = pageSize;
    if (sortColumn) {
      params.sortColumn = sortColumn;
      params.sortDirection = sortDirection || 'asc';
    }
    const effectiveName = filterName || action.payload?.name;
    if (effectiveName) {
      params.search = effectiveName;
    }

    const response = yield call(visitTypeService.getVisitTypes, params);
    yield put(fetchVisitTypesSuccess(response));
  } catch (error) {
    yield put(fetchVisitTypesFailure(error.message));
  }
}

function* handleFetchVisitTypeById(action) {
  try {
    const response = yield call(visitTypeService.getVisitTypeById, action.payload);
    yield put(fetchVisitTypeByIdSuccess(response));
  } catch (error) {
    yield put(fetchVisitTypeByIdFailure(error.message));
  }
}

function* handleAddVisitType(action) {
  try {
    const response = yield call(visitTypeService.createVisitType, action.payload);
    yield put(addVisitTypeSuccess(response));
  } catch (error) {
    yield put(addVisitTypeFailure(error.message));
  }
}

function* handleUpdateVisitType(action) {
  try {
    const response = yield call(visitTypeService.updateVisitType, action.payload);
    yield put(updateVisitTypeSuccess(response));
  } catch (error) {
    yield put(updateVisitTypeFailure(error.message));
  }
}

function* handleDeleteVisitType(action) {
  try {
    const response = yield call(visitTypeService.deleteVisitType, action.payload);
    yield put(deleteVisitTypeSuccess(response));
  } catch (error) {
    yield put(deleteVisitTypeFailure(error.message));
  }
}

function* handleBulkDeleteVisitTypes(action) {
  try {
    const response = yield call(visitTypeService.bulkDeleteVisitTypes, action.payload);
    yield put(bulkDeleteVisitTypesSuccess(response));
  } catch (error) {
    yield put(bulkDeleteVisitTypesFailure(error.message));
  }
}

export function* watchVisitTypesActions() {
  yield takeLatest(fetchInit.type, handleFetchInit);
  yield takeLatest(fetchVisitTypes.type, handleFetchVisitTypes);
  yield takeLatest(fetchVisitTypeById.type, handleFetchVisitTypeById);
  yield takeLatest(addVisitType.type, handleAddVisitType);
  yield takeLatest(updateVisitType.type, handleUpdateVisitType);
  yield takeLatest(deleteVisitType.type, handleDeleteVisitType);
  yield takeLatest(bulkDeleteVisitTypes.type, handleBulkDeleteVisitTypes);
}
